function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.75 0.75)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.209,12.931a.849.849,0,0,1,.116-.428,1.18,1.18,0,0,1,.074-.109,5.68,5.68,0,0,0,.968-3.165,5.963,5.963,0,0,0-6.089-5.854,6.047,6.047,0,0,0-5.97,4.659,5.633,5.633,0,0,0-.13,1.2,5.946,5.946,0,0,0,5.994,5.928,7.219,7.219,0,0,0,1.655-.27c.4-.109.789-.252.89-.291a.927.927,0,0,1,.326-.06.911.911,0,0,1,.354.07l1.988.7a.474.474,0,0,0,.137.035.279.279,0,0,0,.28-.28.45.45,0,0,0-.018-.095Z",
  transform: "translate(-6.495 -3.375)",
  fill: "none",
  stroke: "#01F2B4",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.445,20.45c-.125.035-.293.079-.467.118a3.576,3.576,0,0,1-.893.089,6.013,6.013,0,0,1-5.892-6.086,6.683,6.683,0,0,1,.052-.75c.021-.151.045-.3.08-.449s.076-.315.122-.47l-.278.249a5.2,5.2,0,0,0-.932,6.8c.08.123.125.217.111.28S3.935,22.4,3.935,22.4a.275.275,0,0,0,.271.333.248.248,0,0,0,.1-.021l1.95-.775a.539.539,0,0,1,.417.007,5.807,5.807,0,0,0,2.11.421,4.591,4.591,0,0,0,3.842-1.71s.055-.025.184-.207C12.681,20.5,12.591,20.411,12.445,20.45Z",
  transform: "translate(-3.375 -8.864)",
  fill: "none",
  stroke: "#01F2B4",
  strokeWidth: 1.5
}));

function SvgChatOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.371,
    height: 15.371,
    viewBox: "0 0 15.371 15.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutline);
export default __webpack_public_path__ + "static/media/chatOutline.eb518fa439930b185fb9bce30e966bc1.svg";
export { ForwardRef as ReactComponent };